export default {
  size: {
    xxlarge: '166px'
  }
}
